
import React, { useEffect, useState } from "react";
import { gql } from "@apollo/client";
import { useMutation } from "@apollo/client/react";
import { useSearchParams, Link } from "react-router-dom";



const ACCEPT_INVITATION = gql`
  mutation AcceptOrganizationInvitation(
    $token: String!
    $name: String!
    $login: String!
    $password: String!
  ) {
    acceptOrganizationInvitation(
      token: $token
      name: $name
      login: $login
      password: $password
    ) {
      id
    }
  }
`;

const ACCEPT_EXISTING_INVITATION = gql`
  mutation AcceptExistingOrganizationInvitation($token: String!) {
    acceptExistingOrganizationInvitation(token: $token) {
      id
    }
  }
`;



export default function AcceptInvite(): React.ReactElement {

  
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");

  const [name, setName] = useState("");
  const [login, setLogin] = useState("");
  const [password, setPassword] = useState("");
  const [success, setSuccess] = useState(false);

  const [acceptInvitation, { loading, error }] =
    useMutation(ACCEPT_INVITATION);

  const [
  acceptExistingInvitation,
  {
    loading: existingLoading,
    error: existingError,
  },
] = useMutation(ACCEPT_EXISTING_INVITATION);  

  const handleSubmit = async (
    event: React.FormEvent<HTMLFormElement>
  ) => {
    event.preventDefault();

    if (!token) return;

    try {
      await acceptInvitation({
        variables: {
          token,
          name: name.trim(),
          login: login.trim(),
          password,
        },
      });

      setSuccess(true);
    } catch {
      // Apollo exposes the error through the mutation state.
    }
  };

  const handleExistingUserAccept = async () => {
  if (!token) return;

  try {
    await acceptExistingInvitation({
      variables: { token },
    });

    setSuccess(true);
  } catch (err) {
    console.error("Invitation acceptance failed:", err);
  }
};

  if (!token) {
    return (
      <main style={{ padding: 32 }}>
        <h2>Invalid Invitation</h2>
        <p>The invitation link is missing its token.</p>
        <Link to="/">Return to Login</Link>
      </main>
    );
  }

  if (success) {
    return (
      <main style={{ padding: 32 }}>
        <h2>Invitation Accepted!</h2>
        <p>
          Your portal account has been created and
          added to the organization.
        </p>
        <Link to="/">Continue to Login</Link>
      </main>
    );
  }

  return (
    <main
      style={{
        maxWidth: 440,
        margin: "80px auto",
        padding: 24,
      }}
    >
      <h1>Accept Organization Invitation</h1>

      <div style={{ marginBottom: 24 }}>
  <p>Already logged in to your portal account?</p>

  <button
    type="button"
    onClick={handleExistingUserAccept}
    disabled={existingLoading}
  >
    {existingLoading
      ? "Accepting Invitation..."
      : "Accept Invitation With Existing Account"}
  </button>

  {existingError && (
    <p role="alert" style={{ color: "crimson" }}>
      {existingError.message}
    </p>
  )}
</div>

      <p>Create your account to join the organization.</p>



      <form onSubmit={handleSubmit}>
        <div style={{ marginBottom: 16 }}>
          <label htmlFor="invite-name">Full Name</label>
          <input
            id="invite-name"
            type="text"
            value={name}
            onChange={(e) => setName(e.target.value)}
            required
            style={{ display: "block", width: "100%" }}
          />
        </div>

        <div style={{ marginBottom: 16 }}>
          <label htmlFor="invite-login">Username</label>
          <input
            id="invite-login"
            type="text"
            value={login}
            onChange={(e) => setLogin(e.target.value)}
            required
            style={{ display: "block", width: "100%" }}
          />
        </div>

        <div style={{ marginBottom: 16 }}>
          <label htmlFor="invite-password">Password</label>
          <input
            id="invite-password"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            minLength={8}
            autoComplete="new-password"
            style={{ display: "block", width: "100%" }}
          />
        </div>

        {error && (
          <p role="alert" style={{ color: "crimson" }}>
            {error.message}
          </p>
        )}

        <button type="submit" disabled={loading}>
          {loading ? "Accepting..." : "Accept Invitation"}
        </button>
      </form>

    <Link
  to={`/?redirect=${encodeURIComponent(
    `/accept-invite?token=${token}`
  )}`}
>
  Already have an account? Log in
</Link>
    </main>
  );
}
